
import { appendDescriptionAttribute } from '../../../shared/model-description.util';
import { FirearmAssignablePerson } from './firearm-assignable-person.model';
import { FirearmAssignablePersonTypeInfoBase } from './firearm-assignable-person.typeinfo.base';


export class FirearmAssignablePersonTypeInfo extends FirearmAssignablePersonTypeInfoBase {

  name = 'Firearm Asset Assignable Person';

  description(item: FirearmAssignablePerson): string {
    var description = appendDescriptionAttribute(item?.email);
    description = appendDescriptionAttribute(item?.personType, description, true);
    if (item?.ranger?.volunteerRanger) {
      description = appendDescriptionAttribute('(Volunteer)', description, true, " ");
    }
    return description;
  }
  descriptionShort(item: FirearmAssignablePerson): string {
    return '' + item.email;
  }
}

export const FIREARM_ASSIGNABLE_PERSON_TYPE: FirearmAssignablePersonTypeInfo = new FirearmAssignablePersonTypeInfo();



